import React, { useEffect, useState } from "react";
import logo from "../assets/images/footer-logo.svg";
import { Link } from "react-router-dom";
import fb from "../assets/images/fb.svg";
import insta from "../assets/images/insta.svg";
import twitter from "../assets/images/twitter.svg";
import linkedin from "../assets/images/linked.svg";
import gplay from "../assets/images/gplaystore.svg";
import aplay from "../assets/images/aplaystore.svg";
import { withRouter } from "react-router-dom";
const Footer = ({ location }) => {
  const [show, setShow] = useState(true);
  useEffect(() => {
    if (location.pathname.split("/", 3).join("/") === "/mobile/graph") {
      setShow(false);
    }
  }, [location]);
  return show ? (
    <div className="Footer">
      <div className="Footer__container">
        <div className="Footer__company">
          <div className="Footer__logo">
            <img src={logo} alt="" style={{ width: "50px", height: "50px" }} />
            <span>CoinStorey</span>
          </div>

          <p>
            Coinstorey is a unique platform where one can get basics to advanced
            realisation of crypto market without investing in real. One can
            track coins, analyse data, research the market, get the news, know
            the events and play with advanced graphs. Apart from all these, You
            can invest our Virtual Money to make your portfolios and get rid of
            direct loss in the real market. And, start playing Fantasy trading
            game with full enthusiasm and win in real.
          </p>
        </div>
        <div className="Footer__link-section">
          <div className="Footer__feature">
            {/* <p>Features</p> */}
            {/* <Link className="Footer__link" to="/"> */}
            <a
              className="Footer__link"
              href="https://coinstorey.info"
              rel="noopener noreferrer"
              target="_blank"
            >
              About Us
            </a>
            {/*           
            <Link className="Footer__link" to="/associate">
              Become an Associate
            </Link> */}
            {/* </Link> */}
            <a className="Footer__link"   href="https://forms.gle/QxYg9gK63LNPCh24A"
              rel="noopener noreferrer">
              Contact Us
            </a>
            <Link className="Footer__link" to="/faq">
              FAQ
            </Link>
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSetkTg5pgjeGtOIdNCtYgRw2sctDHy7LkZjQ8FD_NKfO2ZCjg/viewform"
              rel="noopener noreferrer"
              className="Footer__link"
              target="_blank"
              style={{ whiteSpace: "nowrap" }}
            >
              Careers
            </a>
            <Link className="Footer__link" to="/how-to-play">
              How to Play
            </Link>
            <a
              href="https://razorpay.com/"
              rel="noopener noreferrer"
              className="Footer__link"
              target="_blank"
              style={{ whiteSpace: "nowrap" }}
            >
              Payment Partners
            </a>
          </div>
          <div className="Footer__support">
            
            {/* <p>Support</p> */}
            <Link
              className="Footer__link"
              to="/associate"
              style={{ whiteSpace: "nowrap" }}
            >
              Become an Associate
            </Link>
            <a
              href="https://forms.gle/w7jJVApsKNR4xdcB8"
              rel="noopener noreferrer"
              className="Footer__link"
              target="_blank"
              style={{ whiteSpace: "nowrap" }}
            >
              Register a complaint
            </a>
            <Link
              className="Footer__link"
              to="/terms-and-conditions"
              style={{ whiteSpace: "nowrap" }}
            >
              Terms and conditions
            </Link>
            <Link className="Footer__link" to="/privacy-policy">
              Privacy Policy
            </Link>
            <Link className="Footer__link" to="/responsible-play">
              Responsible Play
            </Link>
            <a
              href="https://forms.gle/NEKCihFwBEuMFQzT6"
              rel="noopener noreferrer"
              className="Footer__link"
              target="_blank"
              style={{ whiteSpace: "nowrap" }}
            >
            Report a Bug</a>
      
          </div>
          {/* <div className="Footer__product">
            
            <p>Product</p>
            <Link className="Footer__link" to="/">
              Blockchain
            </Link>
            <Link className="Footer__link" to="/">
              Crypto API
            </Link>
            <Link className="Footer__link" to="/">
              Interest
            </Link>
            <Link className="Footer__link" to="/">
              <pre>Jobs Boards</pre>
            </Link>
          </div>
       */}
        </div>

        <div className="Footer__subscribe-section">
          {/* <div className="Footer__subscribe">
            <input type="text" placeholder="Enter email here" />
            <button>Subscribe</button>
          </div>
        */}
          <p>Find and follow CoinStorey</p>
          <div className="Footer__socialmedia">
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="
https://www.facebook.com/Coinstorey-110659014578492"
            >
              
              <img
                src={fb}
                alt="fb"
                style={{ width: "45px", height: "45px" }}
              />
            </a>
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="
https://www.instagram.com/coinstorey/
"
            >
              <img
                src={insta}
                alt="fb"
                style={{ width: "45px", height: "45px" }}
              />
            </a>
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="
https://www.linkedin.com/company/coinstorey/
"
            >
              
              <img
                src={linkedin}
                alt="fb"
                style={{ width: "45px", height: "45px" }}
              />
            </a>
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="https://twitter.com/coinstorey"
            >
              
              <img
                src={twitter}
                alt="fb"
                style={{ width: "45px", height: "45px" }}
              />
            </a>
          </div>
          <div className="Footer__appdownload">
            <img
              src={aplay}
              alt="fb"
              className="Footer__aplay"
              style={{ width: "50%", height: "auto" }}
            />
            <img
              src={gplay}
              alt="fb"
              className="Footer__gplay"
              style={{ width: "50%", height: "auto" }}
            />
          </div>
        </div>
      </div>
      <hr />
      <center>
        <p className="copyright">
          © 2018 - {new Date().getFullYear()} Hansis IT Supervision Pvt Ltd. All
          Rights Reserved.
        </p>
      </center>
    </div>
  ) : (
    <></>
  );
};

export default withRouter(Footer);
